import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/slice.js";
import teachersReducer from "./teachers/sliсe.js";
import favoritesReducer from "./favorites/slice.js";
import themeReducer from "./themes/slice.js";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["favourites"], // Тільки favourites буде збережено
};

const rootReducer = combineReducers({
  auth: authReducer,
  teachers: teachersReducer,
  favorites: favoritesReducer,
  theme: themeReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
